'use strict';

export default function($stateProvider, appConfig) {
  'ngInject';
  $stateProvider
    .state('documentation', {
      abstract: true,
      url: '/documentation',
      template: '<documentation></documentation>'
    })
    .state('documentation.landing', {
      url: '/landing',
      template: require('./static/landing.html')
    });

    appConfig.documentation.forEach(article => {
      $stateProvider.state(`documentation.${article.name}`, {
        url: `/${article.name}`,
        template: require(`./static/${article.filename}`)
      });
    });
}    



// WEBPACK FOOTER //
// ./client/app/documentation/documentation.routes.js